<template>
  <Modal class="max-w-[600px]!">
    <Modal.Title>Upload details</Modal.Title>
    <div class="h-px bg-[#d4d8e1]" />
    <div class="h-[300px] max-h-[300px] overflow-y-auto">
      <UploadDetailsBody />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'
import UploadDetailsBody from './UploadDetailsBody.vue'
</script>
